import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "@/hooks/use-toast";
import { updateSessionCount } from "../services/add-free-session";

export function useFreeSession() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: ({
      usage_id,
      userId,
      newSessionCount,
    }: {
      usage_id: string;
      userId: string;
      newSessionCount: number;
    }) => updateSessionCount(usage_id, newSessionCount),
    onSuccess: (_, { userId }) => {
      queryClient.invalidateQueries({
        queryKey: [`user`, userId],
      });
      toast({
        title: "Success",
        description: "Succesfully added free session",
      });
    },
    onError: (error) => {
      toast({
        title: "Error",
        description: error.message ?? "Failed to add free session",
        variant: "destructive",
      });
    },
  });
}
